<template>
  <SidebarSettingsGroup
    title="Filters"
    collapsible
    :element-type="element.type"
    data-test="graphics-dataListFilters"
  >
    <div
      v-if="hasPaginationFilter"
      class="sidebar-form-group"
    >
      <div class="flex margin-bottom-sm">
        <label class="sidebar-form-label">
          Start From Row

          <input
            v-model.number="paginationOffset"
            type="number"
            :min="1"
            placeholder="1"
            data-test="graphics-input-start-from-row"
            data-entity="graphics-dataListFilters-setStartFromRow"
          >
        </label>
      </div>

      <div class="flex margin-bottom-sm">
        <label class="sidebar-form-label">
          Rows Per Page

          <input
            v-model.number="paginationLimit"
            type="number"
            :min="1"
            placeholder="10"
            data-test="graphics-input-rows-per-page"
            data-entity="graphics-dataListFilters-setRowsPerPage"
          >
        </label>
      </div>
    </div>

    <hr
      v-if="hasPaginationFilter"
      class="sidebar-divider"
    >

    <div
      v-if="hasPaginationFilter"
      class="sidebar-form-group"
    >
      <label class="sidebar-form-label"> Current Page </label>
      <div class="sidebar-settings__page-controls flex flex-center-all">
        <button
          class="btn btn-sm btn-icon btn-style-b"
          :disabled="paginationPage <= 1"
          data-test="graphics-dataListFilters-previousPage"
          data-entity="graphics-dataListFilters-previousPage"
          @click="incrementPage(-1)"
        >
          <span class="fas fa-backward" />
        </button>
        <input
          v-model.number="paginationPage"
          type="number"
          :min="0"
          data-test="graphics-input-current-page"
          data-entity="graphics-dataListFilters-setCurrentPage"
          class="flex-grow margin-left-md margin-right-md"
        >
        <button
          class="btn btn-sm btn-icon btn-style-b"
          data-test="graphics-dataListFilters-nextPage"
          data-entity="graphics-dataListFilters-nextPage"
          @click="incrementPage(1)"
        >
          <span class="fas fa-forward" />
        </button>
      </div>
    </div>
  </SidebarSettingsGroup>
</template>

<script>
import settingsMixins from '../../mixins/settings-mixins';
import elementDefaults from '../../utils/defaults';

export default {
  mixins: [settingsMixins],
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    filters() {
      return this.getPropertyValue('data.filters', { emptyValue: elementDefaults['data-list'].data.filters, fallbackValue: [] });
    },

    hasPaginationFilter() {
      return !!this.filters.find((f) => f.type === 'pagination');
    },

    paginationIndex() {
      return this.filters.findIndex((filter) => filter.type === 'pagination');
    },

    paginationOffset: {
      get() {
        return this.getPropertyValue(`data.filters.${this.paginationIndex}.offset`);
      },
      set(v) {
        this.updateOneElementValue(`data.filters.${this.paginationIndex}.offset`, v);
      },
    },

    paginationLimit: {
      get() {
        return this.getPropertyValue(`data.filters.${this.paginationIndex}.limit`);
      },
      set(v) {
        this.updateOneElementValue(`data.filters.${this.paginationIndex}.limit`, v);
      },
    },

    paginationPage: {
      get() {
        return this.getPropertyValue(`data.filters.${this.paginationIndex}.page`);
      },
      set(v) {
        this.updateOneElementValue(`data.filters.${this.paginationIndex}.page`, v);
      },
    },
  },
  methods: {
    incrementPage(value) {
      this.paginationPage += value;
    },
  },
};
</script>
